/**
 * Determines if the current vehicle is in the list of vehicles whose insert locations should be restricted.
 *
 * @param {Array} vehicleTitle - The vehicle title array from the vehicle data.
 * @param {string} restrictInsertLocationsForVehicles - The value of the restrictInsertLocationsForVehicles preference.
 */

export const getTargetLocations = (
	vehicle,
	restrictInsertLocationsForVehicles
) => {
	const targetLocations = new Set();

	if (!restrictInsertLocationsForVehicles) {
		return targetLocations;
	}

	// Expected preference value format:
	// classification=wholesale,optionCodes=P0007,optionCodes=P1234:vehicle-ctas,vehicle-badge;classification=fleet:vehicle-media,vehicle-pricing;
	restrictInsertLocationsForVehicles.split(';').forEach((configEntry) => {
		if (configEntry.includes(':')) {
			let matchedCount = 0;
			const [matcherList, targets] = configEntry.split(':');
			const fieldMatchers = matcherList.trim().split(',');

			fieldMatchers.forEach((matcher) => {
				const [fieldName, fieldValue] = matcher.split('=');

				const normalizedFieldName =
					fieldName === 'inventoryType' ? 'type' : fieldName;

				if (Array.isArray(vehicle[normalizedFieldName])) {
					if (vehicle[normalizedFieldName].indexOf(fieldValue) > -1) {
						matchedCount += 1;
					}
				} else if (
					vehicle[normalizedFieldName] &&
					vehicle[normalizedFieldName]
						.toLowerCase()
						.match(fieldValue.toLowerCase())
				) {
					matchedCount += 1;
				}
			});

			if (matchedCount === fieldMatchers.length) {
				targets
					.trim()
					.split(',')
					.forEach((location) => {
						targetLocations.add(location);
					});
			}
		}
	});

	return targetLocations;
};
